// @flow

import ko from 'rgs-knockout';

export type SortingIconParams = {
	columnName: string,
	sorting: {
		sortBy: Observable<string>,
		isSortAsc: Observable<Boolean>,
	},
}

export default class SortingIcon {
	constructor (params: SortingIconParams) {

		const { columnName, sorting: { sortBy, isSortAsc } } = params;

		this.mode = ko.pureComputed(() => {
			let mode;
			if (sortBy() === columnName) {
				mode = isSortAsc() ? 'asc' : 'desc';
			} else {
				mode = 'default';
			}
			return mode;
		});
	}
}